export const SSO_REGISTER_CONTEXT_COOKIE = "knoot_sso_register_context";

export type SsoRegisterRole = "CANDIDATE";

export interface SsoRegisterContext {
  role: SsoRegisterRole;
  fingerprintId: string;
}

export interface SyncSsoUserPayload {
  token: string;
  provider: string;
  role?: SsoRegisterRole;
  fingerprintId?: string;
}
